import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M11.031 2.572 9.064 4.515A.75.75 0 1 1 8.01 3.447l1.968-1.942a3.205 3.205 0 0 1 2.251-.922 3.2 3.2 0 0 1 2.251.922 3.155 3.155 0 0 1 .937 2.236 3.13 3.13 0 0 1-.937 2.236l-3.716 3.67a3.192 3.192 0 0 1-2.251.921 3.214 3.214 0 0 1-2.252-.922.75.75 0 0 1 1.054-1.067 1.691 1.691 0 0 0 1.198.489 1.716 1.716 0 0 0 1.197-.489l3.716-3.67a1.657 1.657 0 0 0 .491-1.168 1.632 1.632 0 0 0-.49-1.169 1.704 1.704 0 0 0-1.198-.489c-.45 0-.882.177-1.197.489Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "m6.292 7.42-3.717 3.67a1.643 1.643 0 0 0-.491 1.169c0 .436.176.857.491 1.168a1.708 1.708 0 0 0 2.395 0l1.672-1.65a.75.75 0 0 1 1.054 1.066l-1.672 1.652a3.204 3.204 0 0 1-2.251.921c-.843 0-1.653-.33-2.252-.921a3.143 3.143 0 0 1-.937-2.236c0-.841.339-1.645.937-2.236l3.717-3.67a3.204 3.204 0 0 1 2.25-.921c.843 0 1.653.33 2.252.921A.75.75 0 1 1 8.686 7.42a1.704 1.704 0 0 0-1.197-.488c-.451 0-.882.177-1.197.488Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  c,
  n
];
function a(r, s) {
  return l(), o("svg", t, [...d]);
}
const _ = { render: a };
export {
  _ as default,
  a as render
};
